import { render, staticRenderFns } from "./AssignShiftV2.vue?vue&type=template&id=7589ee86&"
import script from "./AssignShiftV2.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AssignShiftV2.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports